/**
 * Created by evgenijsenkevic on 23/7/25
 */

cleverapps.overrideStyles(cleverapps.styles.StickersPackView, {
    stickersAmount: {
        x: { align: "center", dx: 10 },
        y: { align: "bottom", dy: -40 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersRewardWindow, {
    source: {
        initPosition: {
            x: { align: "center" },
            y: { align: "center" }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickerView, {
    label: {
        openedPosition: {
            x: { align: "center" },
            y: { align: "top", dy: -245 }
        },
        lockedPosition: {
            x: { align: "center" },
            y: { align: "top", dy: -245 }
        }
    },

    text: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 50 }
    }
});